export const PAYMENT_QR_CODE_URL = 'https://example.com/payment';  // 替换为实际的支付二维码URL 
export enum ROLE_TYPE {
    USER = 0,
    PLANNER = 1,
    ORG = 2,
    AGENT = 3 // 未启用
}

export enum PLANNER_FORM_STATUS {
    NOT_SUBMITTED = 0,
    AUDITING = 1,
    AUDIT_PASSED = 2,
    AUDIT_REJECTED = 3,
    ACCOUNT_DISABLED = 4
}

export enum USER_STATUS {
    NOT_SUBMITTED = 0,
    AUDITING = 1,
    AUDIT_PASSED = 2,
    AUDIT_REJECTED = 3,
    ACCOUNT_DISABLED = 4
}